import React from "react";
import {
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import { LinkParamValue } from "@quest_editor/constants";

const ExternalLinkSection = ({
  linkTitle,
  setLinkTitle,
  linkUrl,
  setLinkUrl,
  linkParams,
  setLinkParams,
  availableLinkParams,
}: {
  linkTitle: string;
  setLinkTitle: React.Dispatch<React.SetStateAction<string>>;
  linkUrl: string;
  setLinkUrl: React.Dispatch<React.SetStateAction<string>>;
  linkParams: LinkParamValue[];
  setLinkParams: React.Dispatch<React.SetStateAction<LinkParamValue[]>>;
  availableLinkParams: { value: LinkParamValue; label: string }[];
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit_link.section.external_link")}
      rows={[
        {
          label: t("quest_edit_link.field.title.name"),
          required: true,
          children: (
            <TextField
              size="small"
              value={linkTitle}
              onChange={(e) => setLinkTitle(e.target.value)}
              placeholder={t("quest_edit_link.field.title.placeholder")}
              sx={{ width: 400 }}
            />
          ),
        },
        {
          label: t("quest_edit_link.field.url.name"),
          required: true,
          children: (
            <TextField
              size="small"
              value={linkUrl}
              onChange={(e) => setLinkUrl(e.target.value)}
              sx={{ width: 500 }}
            />
          ),
        },
        {
          label: t("quest_edit_link.field.param.name"),
          children: (
            <Stack direction="column">
              {availableLinkParams.map((param) => (
                <FormControlLabel
                  key={param.value}
                  control={
                    <Checkbox
                      checked={linkParams.includes(param.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setLinkParams((prev) => [...prev, param.value]);
                        } else {
                          setLinkParams((prev) =>
                            prev.filter((p) => p !== param.value),
                          );
                        }
                      }}
                    />
                  }
                  label={param.label}
                  sx={{ color: "primary.main" }}
                />
              ))}
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default ExternalLinkSection;
